// extracted by mini-css-extract-plugin
export default {"input-container":"LocationSearchBar_input-container__frWfX","hint":"LocationSearchBar_hint__NGpSI"};